// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2f4p8","insightsList":"newBusinessInsightsMenu_insightsList__164M1","active":"newBusinessInsightsMenu_active__3U5LU"};